import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenseReceiptsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.278,
		d: "M16.667 3.813v12.375a.83.83 0 0 1-.415.72l-.826.48a.83.83 0 0 1-.831.002l-1.267-.723-1.24.72a.83.83 0 0 1-.833.001L10 16.667l-1.255.721a.83.83 0 0 1-.833-.001l-1.24-.72-1.267.723a.83.83 0 0 1-.831-.003l-.826-.479a.83.83 0 0 1-.415-.72V3.813c0-.298.158-.572.415-.721l.826-.48a.83.83 0 0 1 .831-.002l1.267.723 1.24-.72a.83.83 0 0 1 .833-.001L10 3.333l1.255-.721a.83.83 0 0 1 .833.001l1.24.72 1.267-.723a.83.83 0 0 1 .831.003l.826.479c.257.149.415.424.415.72",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.278,
		d: "M10 6.667v.673M10 13.333v-.673M11.624 8.393A1.63 1.63 0 0 0 10 7.34c-.83-.079-1.57.52-1.667 1.346 0 .57.403 1.061.962 1.173l1.41.282c.56.112.962.603.962 1.173A1.53 1.53 0 0 1 10 12.66a1.63 1.63 0 0 1-1.624-1.053"
	})]
});
export default SvgExpenseReceiptsinline;
